// This function allow to reference async chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"4771":"97183142","7243":"26782285","8438":"044f82e4","8924":"97183142"}[chunkId] + ".chunk.css";
};